import React, {useState} from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import Button from "@mui/material/Button";
import {useSelector} from "react-redux";
import {TISSUE_OPTIONS} from "../../../pages/UploadSlide/constants";
import {useProcessTask} from "../../../shared/hooks";
import {PROCESS_URL} from "../../../shared/api/urls";
import {setSlideTissue} from "../../../shared/api/setSlideTissue";

const TYPE_OBJ = "qupath";
const VERSION_MODEL = "1";

export const AnnotateSlide = () => {
    const [tissue, setTissue] = useState('');
    const slideId   = useSelector((store) => store.slide.data.id);
    const slideName = useSelector((store) => store.slide.data.name);

    const {processSlide, isProcessing, error} = useProcessTask();
    const [result, setResult] = useState(null); // null | 'success' | 'error' | 'moving'

    const handleAnnotate = async () => {
        if (!tissue || !slideId) return;
        setResult(null);

        // Перемещаем SVS-файл в директорию выбранного типа ткани (Colon/, Lung/ и т.д.)
        // и обновляем tissue на сервере, чтобы AI-сервис нашёл файл по ожидаемому пути.
        try {
            setResult('moving');
            await setSlideTissue(slideId, tissue);
        } catch (e) {
            setResult('error');
            return;
        }

        const postData = {
            direct_svs: slideName,
            name_tis: tissue,
            type_obj: TYPE_OBJ,
            version_model: VERSION_MODEL,
            id_slide: slideId,
            split_tis: 0,
        };

        const response = await processSlide(slideId, postData, PROCESS_URL);
        setResult(response?.success ? 'success' : 'error');
    };

    return (
        <div style={{padding: '4px 0'}} onClick={(e) => e.stopPropagation()}>
            <FormControl fullWidth size="small" sx={{mb: 1}}>
                <Select
                    displayEmpty
                    value={tissue}
                    onChange={(e) => { setTissue(e.target.value); setResult(null); }}
                    sx={{fontSize: '13px'}}
                    renderValue={(v) => {
                        if (!v) return <em style={{color: '#aaa', fontSize: '13px'}}>Выберите тип ИНС</em>;
                        const opt = TISSUE_OPTIONS.find(o => o.value === v);
                        return opt ? opt.label : v;
                    }}
                >
                    <MenuItem value="" disabled><em>Выберите тип ИНС</em></MenuItem>
                    {TISSUE_OPTIONS.map(opt => (
                        <MenuItem key={opt.value} value={opt.value}>{opt.label}</MenuItem>
                    ))}
                </Select>
            </FormControl>

            <Button
                color="primary"
                variant="contained"
                size="small"
                fullWidth
                disabled={!tissue || isProcessing || result === 'moving' || !slideId}
                onClick={handleAnnotate}
                sx={{fontSize: '12px'}}
            >
                {result === 'moving' ? 'Подготовка...' : isProcessing ? 'Отправка...' : 'Разметить'}
            </Button>

            {result === 'success' && (
                <p style={{color: '#388e3c', fontSize: '12px', marginTop: '6px', marginBottom: 0}}>
                    Задача поставлена в очередь
                </p>
            )}
            {(result === 'error' || error) && (
                <p style={{color: '#d32f2f', fontSize: '12px', marginTop: '6px', marginBottom: 0}}>
                    Ошибка при отправке
                </p>
            )}
        </div>
    );
};
